import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-C94XKV64BF');
};

export const logPageView = () => {
  ReactGA.send({ 
    hitType: "pageview", 
    page: window.location.pathname 
  });
};

export const logEvent = (category: string, action: string, label?: string) => {
  ReactGA.event({
    category,
    action,
    label
  });
};